import React from 'react';

export default function ShieldBellIcon() {
    return (
        <svg
            width="104"
            height="128"
            viewBox="0 0 104 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_866_59439)">
                <path
                    d="M47.6376 124.25C49.0213 125.057 49.7131 125.461 50.6895 125.67C51.4472 125.833 52.5528 125.833 53.3105 125.67C54.2869 125.461 54.9787 125.057 56.3624 124.25C68.5378 117.147 102 94.8348 102 64.157V34.267C102 29.2701 102 26.7716 101.183 24.6239C100.461 22.7267 99.2876 21.0338 97.7646 19.6916C96.0407 18.1723 93.7013 17.295 89.0225 15.5405L55.5112 2.97374C54.2119 2.48649 53.5622 2.24286 52.8939 2.14628C52.301 2.06062 51.699 2.06062 51.1061 2.14628C50.4378 2.24286 49.7881 2.48649 48.4888 2.97374L14.9775 15.5405C10.2987 17.295 7.95934 18.1723 6.23536 19.6916C4.71239 21.0338 3.53922 22.7267 2.81725 24.6239C2 26.7716 2 29.2701 2 34.267V64.157C2 94.8348 35.4623 117.147 47.6376 124.25Z"
                    stroke="#0080FF"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M61.5547 72.4453C62.6335 76.4936 60.2441 80.6548 56.2177 81.7395C52.1914 82.8243 48.0528 80.4218 46.9739 76.3735M27.3666 56.2522C26.3867 52.7154 27.4057 48.8916 30.0131 46.3212M52.7502 41.3973C53.5155 40.0129 53.7676 38.3396 53.3277 36.6888C52.4287 33.3151 48.9798 31.3131 45.6245 32.2171C42.2692 33.121 40.278 36.5887 41.1771 39.9623C41.617 41.6131 42.6675 42.9355 44.0187 43.7497M73.3115 43.8742C72.4013 40.3186 69.6173 37.5193 66.081 36.6042M66.1957 50.768C65.2977 47.3983 62.9003 44.5804 59.5309 42.9343C56.1614 41.2882 52.096 40.9488 48.229 41.9906C44.3619 43.0324 41.01 45.3702 38.9106 48.4897C36.8111 51.6091 36.1362 55.2547 37.0342 58.6244C38.52 64.1998 38.2315 68.6477 37.2932 72.0276C36.2238 75.8798 35.6891 77.8059 35.8335 78.1927C35.9988 78.6352 36.1184 78.7566 36.5567 78.9274C36.9398 79.0766 38.5494 78.643 41.7685 77.7757L71.6193 69.7336C74.8384 68.8663 76.448 68.4327 76.7056 68.1108C77.0003 67.7426 77.0434 67.5773 76.9665 67.111C76.8993 66.7034 75.4784 65.3042 72.6366 62.5057C70.1433 60.0503 67.6815 56.3433 66.1957 50.768Z"
                    stroke="#0080FF"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_866_59439">
                    <rect
                        width="104"
                        height="128"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
